import {FC, useCallback, useEffect} from 'react'
import {useHistory} from 'react-router-dom'

const ByToken: FC = () => {
  const history = useHistory()

  const redirectToDashboard = useCallback(() => {
    history.push('/');
  }, [history]);

  useEffect(() => {
    redirectToDashboard()
  }, [redirectToDashboard])
  
  return <></>
}

export {ByToken}